import { Component, OnInit } from "@angular/core";
import { CAPService } from "../../core/services/cap-service";
import { formatDate } from "@angular/common";

@Component({
  selector: "app-suggestion-and-feedback",
  templateUrl: "./suggestion-and-feedback.component.html",
  styleUrls: ["./suggestion-and-feedback.component.css"],
})
export class SuggestionAndFeedbackComponent implements OnInit {
  showRadio = true;
  Country;
  SubmittedBy;
  DateSubmitted;
  today = new Date();
  submitFbsn;
  fbsn;
  SuggestionFeedback;
  IsFeedback = false;
  IsSuggestions = false;

  constructor(private CAPService: CAPService) {
    this.submitFbsn = {};
  }

  ngOnInit(): void {
    this.DateSubmitted = this.dateFormate(this.today);
    this.Country = this.CAPService.country;
    this.SubmittedBy = this.CAPService.enterpriseid;
    this.CAPService.AudiLogin(
      "SuggestionsFeedback",
      this.SubmittedBy
    ).subscribe((data) => {});
  }

  dateFormate(date: Date) {
    const format = 'MM/dd/yyyy';
    const locale = 'en-US';
    var result = formatDate(date,format,locale);
    return result;
  }

  ChangeType(type) {
    if (type == "Feedback") {
      this.fbsn = type;
      this.IsFeedback = true;
      this.IsSuggestions = false;
    } else {
      this.fbsn = type;
      this.IsFeedback = false;
      this.IsSuggestions = true;
    }
  }

  submitFbsnData() {
    debugger;
    this.submitFbsn.Country = this.Country;
    this.submitFbsn.SubmittedBy = this.SubmittedBy;
    this.submitFbsn.Type = this.fbsn;
    this.submitFbsn.SuggestionFeedback = this.SuggestionFeedback;
    if (!this.submitFbsn.SuggestionFeedback) {
      if (this.fbsn == "Suggestions") {
        alert("Please enter your Suggestion!");
      } else {
        alert("Please enter your Feedback!");
      }
    } else {
      this.CAPService.submitFbsn(this.submitFbsn).subscribe((data) => {
        if (data.toString() == "Success") {
          if (this.fbsn == "Suggestions") {
            alert(
              "Thank you for your time and Suggestion! We will soon look into it."
            );
          } else {
            alert("Thank you for your time and Feedback!");
          }
          this.Clear();
        } else {
          alert("Something went wrong.");
        }
      });
      // this.CAPService.GetLoggedInEnterpriseId().subscribe(data =>{
      //   if(data[0].ProfilePicURL == 'NotFound'){
      //     this.submitFbsn.ProfilePicURL = 'NotFound';
      //   }
      //   else{
      //     this.submitFbsn.ProfilePicURL = data[0].ProfilePicURL;
      //   }
      //   this.CAPService.submitFbsn(this.submitFbsn).subscribe(data =>{
      //     if(data.toString() == 'Success'){
      //       if(this.fbsn == 'Suggestions'){
      //         alert('Thank you for your time and Suggestion! We will soon look into it.');
      //       }
      //       else{
      //         alert('Thank you for your time and Feedback!');
      //       }
      //       this.Clear();
      //     }
      //     else{
      //       alert('Something went wrong.');
      //     }
      //   });
      // });
    }
  }

  Clear() {
    this.SuggestionFeedback = "";
  }
}
